import { mountAndSolve } from '../index';

const BEHAVIOR_VERIFICATION_ERROR_CODE = 'behavior_verification_required';

const isBehaviorResponse = (error) => {
  const status = error?.response?.status ?? error?.status;
  const errorCode =
    error?.response?.data?.error_code ?? error?.data?.error_code;
  return status === 401 && errorCode === BEHAVIOR_VERIFICATION_ERROR_CODE;
};

export async function guardApiWithCaptcha({ request, scene }) {
  try {
    return await request({});
  } catch (error) {
    if (!isBehaviorResponse(error)) throw error;

    const { hit_punish, serial_no } =
      error?.response?.data ?? error?.data ?? {};
    const captcha_token = await mountAndSolve({
      captchaType: hit_punish,
      serialNo: serial_no,
      scene,
    });

    return request({
      captcha_token,
      captcha_serial_no: serial_no,
    });
  }
}
